<template>
  <div class=" pwc-register-form">
    <van-nav-bar v-if="!cAnchorApplySubmited" :title="cTitle" left-text="取消" right-text="保存" fixed @click-left="handleReturn(true)" @click-right="handleSaveAnchorApply" />
    <van-nav-bar v-else :title="cTitle" left-arrow fixed @click-left="handleReturn(false)" />

    <pwc-container>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="cInnerIntro" class="pwc-form-title" v-html="cInnerIntro" />

      <van-cell-group title="基本信息" :border="false" class="pwc-self-basic">
        <van-field v-model="name" autofocus :disabled="cAnchorApplySubmited" required label="姓名" />
        <van-field v-model="cAge" required placeholder="请选择" readonly :disabled="cAnchorApplySubmited" label="年龄" is-link @click="handleUpdateSelect(lookups, 'ageRange', 'age', ColumnType.Age)" />
        <!-- <v-menu
        v-if="(cShowF10 || cShowF11 ||cShowF12 || cShowF13 || cShowF14 || cShowF15 ||  cShowF16)" 
        ref="menu"
        v-model="showDate"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto" >
        <template v-slot:activator="{ on, attrs }">
          <van-field  v-model="birthDay"  label="生日"  prepend-icon="mdi-calendar"  readonly  v-bind="attrs" required  v-on="on" :disabled="cAnchorApplySubmited" :validate-on-blur="true"></van-field>
        </template>
        <v-date-picker  v-model="birthDay"  no-title  scrollable  @input="showDate = false"  ></v-date-picker>
      </v-menu> -->
        <van-field v-model="birthDay"  placeholder="生日" label="生日" readonly is-link @click="showTime = !showTime" required/>
        <van-popup v-model="showTime"  position="bottom" :overlay="true">
          <van-datetime-picker v-model="birthDay" type="date" @cancel="showTime = !showTime"  @confirm="onConfirm"  :min-date="minDate"/>
        </van-popup>
        <van-field v-model="email" :disabled="cAnchorApplySubmited" label="邮箱" required />
      
      
      </van-cell-group>

      <van-cell-group v-if="cShowEducation" :disabled="cAnchorApplySubmited" title="教育信息" :border="false" class="pwc-self-student">
        <van-field v-model="eduInstitution" :disabled="cAnchorApplySubmited" label="学校" required />
        <van-field v-if="cIsAcadamyReqired" v-model="acadamy" :disabled="cAnchorApplySubmited" label="学院" :required="cIsAcadamyReqired" />
        <van-field v-model="major" :disabled="cAnchorApplySubmited" label="专业" required />
        <van-field v-model="cGrade" placeholder="请选择" readonly :disabled="cAnchorApplySubmited" label="年级" required is-link @click="handleUpdateSelect(lookups, 'anchorStudentGrades', 'grade', ColumnType.Grade)" />
      </van-cell-group>

      <van-cell-group v-if="cShowWorkInfo" :disabled="cAnchorApplySubmited" title="工作信息" :border="false" class="pwc-self-worker">
        <van-field v-model="company" :disabled="cAnchorApplySubmited" label="公司" required />
        <van-field v-model="title" :disabled="cAnchorApplySubmited" label="职位" required />
        <van-field v-model="cWorkYear" placeholder="请选择" readonly label="工作年限" is-link required @click="handleUpdateSelect(lookups, 'workYearRange', 'yearsOfWork', ColumnType.WorkYear)" />
        <van-field v-model="cIndustry" required placeholder="请选择" is-link readonly label="行业" @click="handleUpdateSelect(applyLookups,'industries','industryId',ColumnType.Industry)" />
        <van-field v-if="cIndustry==='其他'" v-model="industryOther" required label="其他行业" placeholder="请注明" />
      </van-cell-group>
      <van-cell-group
        v-if="cShowWorkInfo"
        title="简历"
        :border="false"
        class="pwc-self-worker"
      >
        <pwc-upload-resume
          :uploaddoclist="cfileList"
          :maxfcnt="1"
        />
      </van-cell-group>

      <!-- <div class="pwc-space-top" /> -->
      <div v-if="!cShowWorkInfo">
        <van-cell-group v-if="(applyLookups.channelType !== 1 || (applyLookups.channelType === 1 && cClassLookup.classes.length > 1)) && (cShowF13 || cShowF12)" title="您希望参加哪一期的课程?">
          <van-field v-model="cClass" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(cClassLookup,'classes','classId',ColumnType.Class)" />
        </van-cell-group>

        <van-cell-group v-if="cClassLookup.classes.length > 1 && (cShowF14 || cShowF16)" title="您感兴趣的课程?">
          <van-field v-model="cClass" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(cClassLookup,'classes','classId',ColumnType.Class)" />
        </van-cell-group>

        <!-- <van-cell-group v-if="(applyLookups.channelType !== 1 || (applyLookups.channelType === 1 && cClassLookup.classes.length > 1)) && (cShowF13||cShowF12 || cShowF14)" title="您希望在以下哪个城市上课?">
          <van-field v-model="cCity" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(applyLookups,'cities','cityId',ColumnType.City)" />
          <van-field v-if="cShowOtherCityField" v-model="cityOtherName" :disabled="cAnchorApplySubmited" label="城市" />
        </van-cell-group> -->

        <!-- <van-cell-group title="您是在以下哪个城市报名该项目的?">
    <van-field v-model="cCityFrom" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(applyLookups,'registerFromCities','registerFromCityId',ColumnType.CityFrom)" />
  </van-cell-group> -->
        <!-- <van-cell-group title="关于海外商务体验，您对以下哪些地区感兴趣?">
    <van-field v-model="cOversea" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(applyLookups,'overseaRegions','overseaRegionIds',ColumnType.Oversea)" />
  </van-cell-group> -->
        <!-- <van-cell-group title="您是从何渠道得知此项目?">
    <van-field v-model="cChannel" is-link readonly @click="handleUpdateSelect(applyLookups,'refereetype','campaignId',ColumnType.Channel)" />
  </van-cell-group> -->

        <van-cell-group
          v-if="cShowF11 || cShowF13 || cShowF14"
          title="最高学位的GPA(GPA的范围是0-999.99)">
          <van-field  v-model="gpa"  type="number"  placeholder="请输入..." required :disabled="cAnchorApplySubmited" />
        </van-cell-group>

        <van-cell-group v-if="cShowF13 || cShowF14" title="您是否有课外活动的经历（校内活动）？">
          <van-field
            v-model="activitiesOnCampus"
            placeholder="请输入..."
            :disabled="cAnchorApplySubmited"
            type="textarea"
            :rows="5"
            :required="cShowF13"
          />
        </van-cell-group>

        <van-cell-group v-if="cShowF13 || cShowF14" title="您是否有课外活动的经历（校外活动）？">
          <van-field
            v-model="activitiesOffCampus"
            placeholder="请输入..."
            :disabled="cAnchorApplySubmited"
            type="textarea"
            :rows="5"
            :required="cShowF13"
          />
        </van-cell-group>

        <!-- <van-cell-group v-if="cShowF13" title="校内所在社团/机构">
    <van-field
      v-model="activitiesOnCampus1"
      placeholder="例如：经贸学院宣传部"
      :disabled="cAnchorApplySubmited"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group>

  <van-cell-group v-if="cShowF13" title="校内社团/机构的任职时间">
    <van-field
      v-model="activitiesOnCampus2"
      placeholder="请选择"
      :disabled="true"
      is-link
      @click="handleShowSelectOnCampusDate"
    />
  </van-cell-group>

  <van-cell-group v-if="cShowF13" title="担任职务">
    <van-field
      v-model="activitiesOnCampus3"
      placeholder="例如：部长"
      :disabled="cAnchorApplySubmited"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group>

  <van-cell-group v-if="cShowF13" title="职务内容">
    <van-field
      v-model="activitiesOnCampus4"
      placeholder="例如：2018年参与迎新晚会宣传活动，在全校范围、全院范围通过微信、微博、发传单进行推广，累积参与人次达到500人"
      :disabled="cAnchorApplySubmited"
      type="textarea"
      :rows="5"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group>

  <van-cell-group v-if="cShowF13" title="校外所在企业/机构">
    <van-field
      v-model="activitiesOffCampus1"
      placeholder="例如：普华永道"
      :readonly="cAnchorApplySubmited"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group>
  <van-cell-group v-if="cShowF13" title="校外企业/机构的任职时间">
    <van-field
      v-model="activitiesOffCampus2"
      placeholder="请选择"
      is-link
      :readonly="true"
      @click="handleShowSelectOffCampusDate"
    />
  </van-cell-group>
  <van-cell-group v-if="cShowF13" title="担任职务">
    <van-field
      v-model="activitiesOffCampus3"
      placeholder="例如：XX部门Marketing实习生"
      :readonly="cAnchorApplySubmited"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group>
  <van-cell-group v-if="cShowF13" title="职务内容">
    <van-field
      v-model="activitiesOffCampus4"
      placeholder="例如：Marketing文档整合，总计100份；完成市场信息收集，协助完成200页的市场分析报告"
      :disabled="cAnchorApplySubmited"
      type="textarea"
      :rows="5"
      :required="cShowF11 || cShowF13"
    />
  </van-cell-group> -->
        <!-- <van-cell-group v-if="cShowF14" title="You Plus 团队联系人">
          <van-field v-model="cFcpId" placeholder="请选择" is-link readonly required @click="handleUpdateSelect(usroadshowfcps,'fcps','fcpId',ColumnType.usfcp)" />
        </van-cell-group> -->
        <van-checkbox-group v-if="cShowF15 || cShowF16" v-model="parentSupportReason">
          <van-cell-group title=" " />
          <van-cell title="父母支持你参与Anchor项目的原因是什么? （可多选）" required />
          <van-cell-group>
            <van-cell
              v-for="(item) in applyLookups.parentSupportReasons"
              :key="item.id"
              clickable
              :title="`${item.name}`"
            >
              <template #right-icon>
                <van-checkbox ref="checkboxes" shape="square" :disabled="cAnchorApplySubmited" :name="item.id" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
        <van-cell-group v-if="cShowF15 || cShowF16" title="家庭对你职业规划、职业发展的期待是什么？ 请阐述家人做了哪些事或将做哪些事，以帮助你提高个人职业竞争力。">
          <van-field v-model="familyExpect" type="textarea" :disabled="cAnchorApplySubmited" placeholder="请输入" :rows="5" />
        </van-cell-group>
        <van-cell-group v-if="(applyLookups.refereetype || []).length > 1" title="推荐人类型">
          <van-field v-model="cRefereeTypeId" placeholder="请选择" is-link readonly @click="handleUpdateSelect(applyLookups,'refereetype','refereeTypeId',ColumnType.RefereeType)" />
        </van-cell-group>
      </div>
      <van-cell-group v-if="cRefereeTypeId" title="推荐人" :border="false" class="pwc-self-basic">
        <van-field v-model="refereeName" :disabled="cAnchorApplySubmited" label="姓名" />
      </van-cell-group>

      <van-button
        :disabled="submitDisabled"
        class="pwc-action-submit"
        block
        replace
        square
        type="primary"
        @click="handleSubmitAnchorApply"
      >{{ cAnchorApplySubmited?'已提交':'提交' }}</van-button>
      <div v-if="!submitDisabled" class="pwc-action-tip">* 提交后不可修改</div>

      <div class="pwc-space-bottom" />
    </pwc-container>

    <pwc-term :show.sync="showTermDialog" :term="term" :confirm="handleConfirm" />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker value-key="name" :columns="cColumns" :default-index="defaultIndex" @change="handlePickerChange" />
    </van-popup>
    <!-- <van-popup v-model="showOnCampusDate" position="bottom">
      <van-picker show-toolbar :columns="cDateColumn" @cancel="handleOnDateCancel" @confirm=" handleOnCampusDateConfirm" />
    </van-popup>
    <van-popup v-model="showOffCampusDate" position="bottom">
      <van-picker show-toolbar :columns="cDateColumn" @cancel="handleOnDateCancel" @confirm=" handleOffCampusDateConfirm" />
    </van-popup> -->
  </div>
</template>

<script>
import { Dialog, NavBar, Cell, CellGroup, Field, Picker, Popup, Button, Checkbox, CheckboxGroup, DatetimePicker } from 'vant'
import { logic } from '../common/mixin/logic'
import PwcTerm from '@/components/PwcTerm/mobile'
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import PwcUploadResume from '@/components/PwcUploadResume'
import { dateYMD } from '@/util/date'
const ColumnType = {
  Age: 0,
  Grade: 1,
  WorkYear: 2,
  Class: 3,
  City: 4,
  Oversea: 5,
  Channel: 6,
  RefereeType: 7,
  CityFrom: 8,
  usfcp: 9,
  Industry: 10
}

const Years = ['2010年', '2011年', '2012年', '2013年',
  '2014年', '2015年', '2016年', '2017年', '2018年', '2019年',
  '2020年', '2021年', '2022年', '2023年', '2024年', '2025年',
  '2026年', '2027年', '2028年', '2029年', '2030年'
]
const Months = ['1月', '2月', '3月', '4月', '5月', '6月',
  '7月', '8月', '9月', '10月', '11月', '12月'
]

export default {
  components: {
    VanNavBar: NavBar,
    VanCell: Cell,
    VanCellGroup: CellGroup,
    VanField: Field,
    VanPicker: Picker,
    VanPopup: Popup,
    VanButton: Button,
    VanCheckbox: Checkbox,
    VanCheckboxGroup: CheckboxGroup,
    VanDatetimePicker: DatetimePicker,
    PwcContainer,
    PwcTerm,
    PwcUploadResume,
  },
  mixins: [logic],
  data() {
    return {
      showPicker: false,
      showOnCampusDate: false,
      showOffCampusDate: false,
      defaultIndex: 0,
      CurrentColType: ColumnType.Age,
      ColumnType
    }
  },
  computed: {
    cfileList() {
      if (this.userInfo.resumes && this.userInfo.resumes.length > 0) {
        const files = this.userInfo.resumes.map(r => {
          return { file: { name: decodeURI(r.item1), url: r.item2 }}
        })

        return files
      }
      return []
    },
    cColumns() {
      switch (this.CurrentColType) {
        case ColumnType.Age:
          return this.lookups.ageRange || []
        case ColumnType.Grade:
          return this.lookups.anchorStudentGrades || []
        case ColumnType.WorkYear:
          return this.lookups.workYearRange || []
        case ColumnType.Class:
          return this.cClassLookup.classes || []
        case ColumnType.City:
          return this.applyLookups.cities || []
        case ColumnType.Oversea:
          return this.applyLookups.overseaRegions || []
        case ColumnType.Channel:
          return this.applyLookups.refereetype || []
        case ColumnType.RefereeType:
          return this.applyLookups.refereetype || []
        case ColumnType.CityFrom:
          return this.applyLookups.registerFromCities
        case ColumnType.usfcp:
          return this.usroadshowfcps.fcps
        case ColumnType.Industry:
          return this.applyLookups.industries
      }

      return []
    },
    cDateColumn() {
      return [
        {
          values: Years,
          className: 'YearStart'
        },
        {
          values: Months,
          className: 'MonthStart'
        },
        {
          values: ['——'],
          className: 'Separator'
        },
        {
          values: Years,
          className: 'YearEnd'
        },
        {
          values: Months,
          className: 'MonthEnd'
        }
      ]
    },
    cAge() {
      return this.getLookupV(this.lookups, 'ageRange', 'age')
    },
    cGrade() {
      return this.getLookupV(this.lookups, 'anchorStudentGrades', 'grade')
    },
    cWorkYear() {
      return this.getLookupV(this.lookups, 'workYearRange', 'yearsOfWork')
    },
    cClass() {
      return this.getLookupV(this.cClassLookup, 'classes', 'classId')
    },
    cCity() {
      return this.getLookupV(this.applyLookups, 'cities', 'cityId')
    },
    cCityFrom() {
      return this.getLookupV(this.applyLookups, 'registerFromCities', 'registerFromCityId')
    },
    cOversea() {
      return this.getLookupV(this.applyLookups, 'overseaRegions', 'overseaRegionIds')
    },
    cRefereeTypeId() {
      return this.getLookupV(this.applyLookups, 'refereetype', 'refereeTypeId')
    },
    cFcpId() {
      return this.getLookupV(this.usroadshowfcps, 'fcps', 'fcpId')
    },
    cIndustry() {
      return this.getLookupV(this.applyLookups, 'industries', 'industryId')
    }
    // cChannel() {
    //   return this.getLookupV(this.applyLookups, 'refereetype', 'campaignId')
    // }
  },
  methods: {
    dateFormat(time) { // 时间格式化
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' + day;
    },
    getLookupV(lookups, name, prop, needDefault = true) {
      if (needDefault && (lookups[name] || []).length === 1) {
        this[prop] = lookups[name][0].id
      }
      const obj = (lookups[name] || []).find(v => v.id === this[prop])
      if (obj) {
        return obj.name
      }
      // return this[prop]
      return ''
    },
    handleDialogConfirm(cb) {
      // component implemented
      Dialog.confirm({
        message: '确认取消修改？'
      }).then(() => {
        cb()
      }).catch(() => {
        // cancel return, do nothing
      })
    },
    handleDialogMessage(msg) {
      // component implemented
      Dialog.alert({
        message: msg
      })
    },
    handlePickerChange(i, v) {
      this.showPicker = false
      switch (this.CurrentColType) {
        case ColumnType.Age:
          this.age = v.id
          break
        case ColumnType.Grade:
          this.grade = v.id
          break
        case ColumnType.WorkYear:
          this.yearsOfWork = v.id
          break
        case ColumnType.Class:
          this.classId = v.id
          break
        case ColumnType.City:
          this.cityId = v.id
          break
        case ColumnType.Oversea:
          this.overseaRegionIds = v.id
          break
        case ColumnType.RefereeType:
          this.refereeTypeId = v.id
          break
        case ColumnType.CityFrom:
          this.registerFromCityId = v.id
          break
        case ColumnType.usfcp:
          this.fcpId = v.id
          break
        case ColumnType.Industry:
          this.industryId = v.id
        // case ColumnType.Channel:
        //   this.campaignId = v.id
        //   break
      }
    },
    handleUpdateSelect(lookups, name, prop, tp) {
      if (this.cAnchorApplySubmited) {
        return
      }
      this.showPicker = true
      const index = (lookups[name] || []).findIndex(v => v.id === this[prop])
      if (index === -1) {
        this.defaultIndex = 0
        this[prop] = lookups[name][0].id
      }
      this.CurrentColType = tp
    },
    handleUpdateIndustry() {
      this.showPicker = true
      this.defaultIndex = (this.lookups.industries || []).findIndex(v => v.id === this.industryId)
      this.ColType = ColumnType.Industry
    },
    onConfirm(value) {
        this.birthDay = dateYMD(value)
        this.showTime = !this.showTime;         
    },
    // handleShowSelectOnCampusDate() {
    //   if (!this.cAnchorApplySubmited) {
    //     this.showOnCampusDate = true
    //   }
    // },
    // handleShowSelectOffCampusDate() {
    //   if (!this.cAnchorApplySubmited) {
    //     this.showOffCampusDate = true
    //   }
    // },
    // handleOnDateCancel() {
    //   this.showOnCampusDate = false
    //   this.showOffCampusDate = false
    // },
    // handleOnCampusDateConfirm(info) {
    //   this.showOnCampusDate = false

    //   const start = `${info[0]}${info[1]}`
    //   const end = `${info[3]}${info[4]}`
    //   if (start > end) {
    //     return this.handleDialogMessage('开始时间不能晚于结束时间')
    //   }
    //   this.activitiesOnCampus2 = `${info[0]}${info[1]} - ${info[3]}${info[4]}`
    // },
    // handleOffCampusDateConfirm(info) {
    //   this.showOffCampusDate = false

    //   const start = `${info[0]}${info[1]}`
    //   const end = `${info[3]}${info[4]}`
    //   if (start > end) {
    //     return this.handleDialogMessage('开始时间不能晚于结束时间')
    //   }
    //   this.activitiesOffCampus2 = `${info[0]}${info[1]} - ${info[3]}${info[4]}`
    // }
  }
}
</script>

<style lang="scss" scoped>
.pwc-register-form {
  .pwc-space-top {
    margin-top: 24px;
  }
  .pwc-form-title {
    padding-top: 12px;
    padding-left: 6px;
    padding-right: 6px;
    margin-top: 12px;
    background-color: #fff;
  }
  .pwc-space-bottom {
    margin-bottom: 64px;
  }
  .pwc-action-submit {
    margin: auto;
    margin-top: 24px;
    width: 86%;
  }
  .pwc-action-tip {
    margin: auto;
    margin-top: 6px;
    width: 86%;
    font-size: 12px;
    color: #d04a02;
  }
}
</style>

<style lang="scss" >
.pwc-register-form {
  .YearStart, .YearEnd, .MonthStart, .MonthEnd, .Separator {
    ul, ol {
      padding-left: 0;
    }
  }
  input[disabled] {
   color: #323233;
  }
  textarea[disabled] {
   color: #323233;
  }
}
.v-date-picker-table .v-btn.v-btn--active {
   color: red;
}
.v-picker__title{
  color: rgb(0,0,0)
}
.v-input__prepend-outer{
  display: none;
}
</style>
